import { useParams } from "react-router-dom"
import config from "../../../../config/config"
import CustomListContainer from "../../../../../core/components/core/Util/List/CustomList/CustomListContainer"
import CustomList from "../../../../../core/components/core/Util/List/CustomList/CustomList"
import Toast from "../../../../../core/components/core/Util/Toast/Toast"
import Fetch from "../../../../../core/util/core/Fetch"

function Emails() {
  const { id } = useParams()

  const pathFrontEnd = '/entitymanagers/'
  const pathBackEnd = config.endpoints.backend + 'entitymanagers/'

  const paths = {
    endpoint: `${pathBackEnd}getEmailsByManagerId`,
    endpointDelete: `${pathBackEnd}deleteEmail`,
    endpointSave: `${pathBackEnd}saveEmail`,
    endpointGetById: `${pathBackEnd}getByEmailId`,

    urlGoBack: `${pathFrontEnd}list`
  }

  const labels = {
    labelTitleEdit: "Editar Email",
    labelTitleView: "Visualizar Email",
    labelTitleAdd: "Novo Email"
  }

  const form = {
    containerType: 'dialog',
    validateOnChange: true,
    hiddenValues: {
      manager_id: id
    },
    fields: [
      {
        label: 'Tipo',
        type: 'select',
        options: [{
          label: "Institucional",
          value: "INSTITUCIONAL"
        },
        {
          label: "Pessoal",
          value: "PESSOAL"
        },
        {
          label: "Comercial",
          value: "COMERCIAL"
        }],
        name: 'type',
        validations: {
          required: true
        }
      },
      {
        label: 'Email',
        type: 'email',
        name: 'email',
        maxLength: 100,
        validations: {
          required: true
        }
      }
    ],
    ...paths,
    ...labels
  }

  const list = {
    type: 'dialog',
    labelTitle: 'Lista de Emails',
    handleConfirmDelete: async (item) => {
      const response = await Fetch.delete(paths.endpointDelete, { email_id: item.id, id })
      const { status } = response
      if (status === 0) {
        Toast.error('Erro ao deletar o email');
        return false
      }
      Toast.success('Email deletado com sucesso');
    },
    filter: {
      id
    },
    fieldsShowOnDelete: ['email'],
    columns: [
      {
        name: 'label',
        label: 'Tipo',
      },
      {
        name: 'email',
        label: 'Email'
      }
    ],
    ...paths,
    ...labels
  };

  list.form = form;

  return (
    <CustomListContainer
      labelTitle={list.labelTitle}
      labelTitleButtonAdd={list.labelTitleAdd}
      list={list}
      form={form}
      showInnerModal={false}
      content={<CustomList list={list} />}
    />
  )
}

export default Emails
